import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=73ec4c42"
import script from "./Request.vue?vue&type=script&lang=ts"
export * from "./Request.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ec4c42')) {
      api.createRecord('73ec4c42', component.options)
    } else {
      api.reload('73ec4c42', component.options)
    }
    module.hot.accept("./Request.vue?vue&type=template&id=73ec4c42", function () {
      api.rerender('73ec4c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/Request.vue"
export default component.exports